import type { FaireProductEntity } from "../../entity_types/product";

export const ai_bulk_2: FaireProductEntity = {
  token: "ai_bulk_2",
  type: "product",
  name: "Cubebot\u00AE & Milo Family Set",
  brandName: "Ai Bulk Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/85918193606a1dc21c3b6b965abc33f2303a12ad82ae1d63caa2b8ec00a48dd0.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 37.25,
  msrpDollars: 74.5,
  description: "",
  tags: ["women-owned"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
